import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signInWithEmailAndPassword, sendPasswordResetEmail } from "firebase/auth";
import { auth } from '../firebase-config';
import './Login.css';

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate('/');
    } catch (error) {
      alert(error.message);
    }
  };

  const handlePasswordReset = async () => {
    if (!email) {
      alert("Please enter your email first.");
      return;
    }
    try {
      await sendPasswordResetEmail(auth, email);
      alert("Password reset email sent!");
    } catch (error) {
      alert(error.message);
    }
  };

  return (
    <form onSubmit={handleLogin} className="signup-form">
      <div className="input-group">
        <i className="fas fa-envelope icon"></i>
        <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Adres e-mail" required />
      </div>
      <div className="input-group">
        <i className="fas fa-lock icon"></i>
        <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Hasło" required />
      </div>
      <button type="submit">Zaloguj się!</button>
      <div className="login-links">
        {/* Zmiana <a> na <button> */}
        <button
          type="button"
          onClick={handlePasswordReset}
          className="link-button"
        >
          Zapomniałeś hasła?
        </button>
      </div>
    </form>
  );
}

export default Login;
